export default __webpack_public_path__ + "static/media/product_3_box_bg.2da12f2e.png";